export default __webpack_public_path__ + "static/media/034-aurora borealis.c67a977e.svg";